import { Directive, Inject, Input, OnDestroy, OnInit } from 'angular-ts-decorators';

@Directive({
  selector: '[showMoreToggle]',
})
export class ShowMoreToggleDirective implements OnInit, OnDestroy {
  public static $inject: ReadonlyArray<string> = ['$element'];

  @Input('@') public showMoreToggleExpandSelector?: string;
  @Input('@') public showMoreToggleExpandContentSelector?: string;
  @Input('@') public showMoreToggleCollapseSelector?: string;

  private $expandElement?: JQuery;
  private $parentElement?: JQuery;
  private $collapseElement?: JQuery;
  private expanded = false;

  constructor(@Inject('$element') private $element: JQLite) { }

  public ngOnInit(): void {
    this.$parentElement = this.$element.parent();
    this.$element.on('click', this.onClick.bind(this));
  }

  public ngOnDestroy(): void {
    this.$element.off('click', this.onClick);
    this.$expandElement?.off('mouseleave', this.collapse);
    this.$collapseElement?.off('click', this.collapse.bind(this));
  }

  public onClick() {
    if (!this.$expandElement) {
      this.$expandElement = this.$parentElement.find(this.showMoreToggleExpandSelector);
      this.$expandElement.on('mouseleave', this.collapse.bind(this));
    }

    if (!this.$collapseElement) {
      this.$collapseElement = this.$parentElement.find(this.showMoreToggleCollapseSelector);
      this.$collapseElement.on('click', this.collapse.bind(this));
    }

    this.toggle();
  }

  private toggle() {
    this.expanded ? this.collapse() : this.expand();
  }

  private expand() {
    const $expandContentElement: JQuery = this.$parentElement.find(this.showMoreToggleExpandContentSelector);
    this.$expandElement.outerHeight($expandContentElement.outerHeight());
    this.expanded = true;
  }

  private collapse() {
    this.$expandElement.outerHeight(0);
    this.expanded = false;
  }
}
